import {
  AdminTableHeader,
  adminFilterDateInputClasses,
  adminFilterDropdownTriggerClass,
} from '../shared/adminUx';
import React from 'react';
import PostsSection from './PostsSection';

const AllPosts = () => {
  return <PostsSection pageTitle="Posts" defaultFilters={{}} />;
};

export default AllPosts;

